import type { FC } from 'react';
import { useMemo } from 'react';
import clsx from 'clsx';

import Button from '@trend-dev/trendtech-ui/components/UI/Button';
import { Icon } from '@trend-dev/ui-libs-icons';

import { useControlStore } from 'store/controls';
import { useSizeStore } from 'store/size';

import { controlsId } from 'components/Pages/Call/Wrapper/hooks/useFullSizeControls';

import { useCameraContext } from './CameraPermissionContext';
import { useControlActions } from './hooks/useControlActions';
import { useControlView } from './hooks/useControlView';
import styles from './styles.module.scss';

const Controls: FC = () => {
    const controlAction = useControlActions();
    const { controls } = useControlStore();
    const { isFull } = useSizeStore();
    const controlList = useControlView();
    const { granted } = useCameraContext();

    const renderBadge = useMemo(() => {
        if (granted) return null;

        return (
            <div className={styles.hint}>
                <Icon name='InfoFilled_20' />
            </div>
        );
    }, [granted]);

    return (
        <ul id={controlsId} className={clsx(styles.wrapper, { [styles.wrapperIsFull]: isFull })}>
            {controlList.map(({ className, getIcon, label, storeType, type }) => {
                const isActive = storeType ? controls[storeType] : false;

                return (
                    <li key={type} className={clsx({ [styles.controlIsActive]: isActive }, styles.control, className)}>
                        <div className={styles.buttonWrapper} onClick={controlAction(type)}>
                            <Button
                                className={clsx(styles.icon, storeType ?? undefined)}
                                borderRadius='full'
                                onlyIcon
                                insideIndent={3}
                                size='lg'
                                kind='gray'
                            >
                                {getIcon(isActive)}
                            </Button>
                            {type === 'cam' ? renderBadge : null}
                        </div>
                        <span className={styles.controlLabel}>{label}</span>
                    </li>
                );
            })}
        </ul>
    );
};

export default Controls;
